export const BASE = {
  name: 'permission-required',
  path: '/sites/:siteId/permission-required',
};
